import axios from 'axios'

class Config {
    getConfig = () => axios.get('')
}

export default new Config()
